import mom from 'moment';
const sos = mom;

sos.locale('en');
sos.defaultFormat = 'YYYY-MM-DD HH:mm:ss';
sos.defaultFormatUtc = 'YYYY-MM-DD HH:mm:ss';

export const moment = sos as typeof mom;
